import Cookies from 'js-cookie';

import { UTM_VARIANT_COOKIE_NAME } from '@constants/appConstants';

const cookieOptions = {
  expires: 30,
  path: '/',
  sameSite: 'lax' as const,
  secure: window.location.protocol === 'https:',
};

/**
 * Records whether `utm_variant` was present on the URL when the user landed, independent of
 * LaunchDarkly. Callers should only consult LD flags targeted on `utm_variant` when this is
 * true, so that check doesn't depend solely on LD's own targeting rule to stay off for traffic
 * without a utm_variant.
 */
export function setUtmVariantCookie(hasVariant: boolean): void {
  Cookies.set(UTM_VARIANT_COOKIE_NAME, String(hasVariant), cookieOptions);
}

export function hasUtmVariantCookie(): boolean {
  return Cookies.get(UTM_VARIANT_COOKIE_NAME) === 'true';
}
